import { useEffect, useState } from 'react';
import { ONELIVE_OPEN_CHANNELS } from './api';
import OneliveMobileChannelDrawer from './OneliveMobileChannelDrawer';

/** Global mobile drawer — mounted once in _user_base so hamburger works on every page. */
export default function OneliveMobileDrawerHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(ONELIVE_OPEN_CHANNELS, handler);
    return () => window.removeEventListener(ONELIVE_OPEN_CHANNELS, handler);
  }, []);

  return <OneliveMobileChannelDrawer open={open} onClose={() => setOpen(false)} />;
}
